import { createAction, props } from '@ngrx/store';

export const getNotifications = createAction('[Notifications] Get');
export const storeNotifications = createAction('[Notifications] Store', props<{ list: any }>());
export const updateIsActiveNotifications = createAction(
  '[Notifications] Update isActive',
  props<any>(),
);
